export var permissionUtil = {
  has: function has(_ref) {
    var _permissions$filter;
    var permissions = _ref.permissions,
      entities = _ref.entities;
    return (permissions === null || permissions === void 0 || (_permissions$filter = permissions.filter(function (p) {
      return p.e === 'ALL' || entities.indexOf(p.e) > -1;
    })) === null || _permissions$filter === void 0 ? void 0 : _permissions$filter.length) > 0;
  }
};